// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const inp = {
  width: '100%', background: C.bg, border: `1px solid ${C.border}`,
  borderRadius: '8px', padding: '10px 14px', fontSize: '16px',
  fontFamily: fs, color: C.brown, boxSizing: 'border-box', outline: 'none',
  WebkitUserSelect: 'text', userSelect: 'text', touchAction: 'manipulation',
}
const lbl = {
  fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
  textTransform: 'uppercase', fontFamily: fs, display: 'block', marginBottom: '5px',
}

const CONTRACTOR_CATEGORIES = [
  'HVAC', 'Plumbing', 'Electrical', 'Roofing', 'Landscaping',
  'Appliance Repair', 'Handyman', 'Housekeeping', 'Pest Control',
  'Pool Service', 'Window Cleaning', 'Gutter Cleaning',
  'General Contractor', 'Painting', 'Flooring',
]

const SERVICE_AREAS = [
  'Marin County', 'Sonoma County', 'Napa County', 'Solano County', 'San Francisco', 'East Bay'
]

const PRICE_RANGES = [
  { id: 'budget', label: '$ — Budget-friendly' },
  { id: 'mid', label: '$$ — Mid-range' },
  { id: 'premium', label: '$$$ — Premium' },
]

export default function ContractorJoin({ supabase: supabaseProp }) {
  const db = supabaseProp || supabase
  const [step, setStep] = useState(1)
  const [form, setForm] = useState({
    business_name: '', contact_name: '', email: '', phone: '',
    categories: [], service_areas: [], price_range: '',
    bio: '', license_number: '', insurance_confirmed: false,
    website: '',
  })
  const [saving, setSaving] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }))
  const toggleArr = (key, val) => setForm(p => ({
    ...p,
    [key]: p[key].includes(val) ? p[key].filter(x => x !== val) : [...p[key], val],
  }))

  const handleSubmit = async () => {
    if (!form.business_name.trim() || !form.email.trim() || form.categories.length === 0) {
      setError('Business name, email, and at least one category are required.')
      return
    }
    setSaving(true)
    setError('')
    const { error: err } = await db.from('contractors').insert({
      business_name: form.business_name.trim(),
      contact_name: form.contact_name.trim() || null,
      email: form.email.trim(),
      phone: form.phone.trim() || null,
      categories: form.categories,
      service_areas: form.service_areas,
      price_range: form.price_range || null,
      bio: form.bio.trim() || null,
      license_number: form.license_number.trim() || null,
      insurance_confirmed: form.insurance_confirmed,
      website: form.website.trim() || null,
      status: 'pending_review',
    })
    setSaving(false)
    if (err) {
      setError('Submission failed. Please try again.')
    } else {
      setSubmitted(true)
    }
  }

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', fontFamily: fs }}>
        <div style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
          <div style={{ fontFamily: f, fontSize: '24px', color: C.brown, marginBottom: '12px' }}>Application Received</div>
          <div style={{ fontSize: '15px', color: C.muted, lineHeight: 1.6, marginBottom: '24px' }}>
            Thanks for applying to Casavio's contractor network. We'll review your application and reach out within 2–3 business days.
          </div>
          <div style={{ fontSize: '13px', color: C.muted }}>Questions? Email <a href="mailto:hello@casavio.com" style={{ color: C.amber }}>hello@casavio.com</a></div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: fs }}>
      {/* Header */}
      <div style={{ background: C.card, borderBottom: `1px solid ${C.border}`, padding: '20px 24px' }}>
        <div style={{ maxWidth: 560, margin: '0 auto' }}>
          <div style={{ fontFamily: f, fontSize: '22px', color: C.brown, marginBottom: '4px' }}>Join Casavio Contractors</div>
          <div style={{ fontSize: '13px', color: C.muted }}>Connect with North Bay homeowners who need your services</div>
        </div>
      </div>

      <div style={{ maxWidth: 560, margin: '0 auto', padding: '24px 20px 60px' }}>
        {/* Step indicators */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '28px' }}>
          {[1, 2, 3].map(s => (
            <div key={s} style={{ flex: 1, height: '3px', borderRadius: '2px', background: s <= step ? C.amber : C.border, transition: 'background 0.2s' }} />
          ))}
        </div>

        {step === 1 && (
          <div>
            <div style={{ fontFamily: f, fontSize: '18px', color: C.brown, marginBottom: '20px' }}>Business Information</div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Business Name *</label>
              <input style={inp} value={form.business_name} onChange={e => set('business_name', e.target.value)} placeholder="e.g. Marin HVAC Services" autoFocus />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Your Name</label>
              <input style={inp} value={form.contact_name} onChange={e => set('contact_name', e.target.value)} placeholder="Owner or primary contact" />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Email *</label>
              <input style={inp} type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="contact@yourbusiness.com" />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Phone</label>
              <input style={inp} type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(415) 555-0100" />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Website (optional)</label>
              <input style={inp} value={form.website} onChange={e => set('website', e.target.value)} placeholder="https://..." />
            </div>
            <button
              onClick={() => { if (!form.business_name.trim() || !form.email.trim()) { setError('Business name and email are required.'); return }; setError(''); setStep(2) }}
              style={{ width: '100%', background: C.amber, color: '#fff', border: 'none', borderRadius: '10px', padding: '14px', fontFamily: f, fontSize: '16px', cursor: 'pointer', marginTop: '8px' }}
            >
              Next →
            </button>
          </div>
        )}

        {step === 2 && (
          <div>
            <div style={{ fontFamily: f, fontSize: '18px', color: C.brown, marginBottom: '20px' }}>Services & Coverage</div>

            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Service Categories * (select all that apply)</label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                {CONTRACTOR_CATEGORIES.map(cat => (
                  <label key={cat} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: form.categories.includes(cat) ? '#FFF8E7' : C.card, border: `1px solid ${form.categories.includes(cat) ? C.amber : C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '13px', color: C.brown }}>
                    <input type="checkbox" checked={form.categories.includes(cat)} onChange={() => toggleArr('categories', cat)} style={{ accentColor: C.amber, flexShrink: 0 }} />
                    {cat}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Service Areas</label>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                {SERVICE_AREAS.map(area => (
                  <label key={area} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', background: form.service_areas.includes(area) ? '#FFF8E7' : C.card, border: `1px solid ${form.service_areas.includes(area) ? C.amber : C.border}`, borderRadius: '8px', cursor: 'pointer', fontSize: '13px', color: C.brown }}>
                    <input type="checkbox" checked={form.service_areas.includes(area)} onChange={() => toggleArr('service_areas', area)} style={{ accentColor: C.amber, flexShrink: 0 }} />
                    {area}
                  </label>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={lbl}>Price Range</label>
              {PRICE_RANGES.map(p => (
                <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0', cursor: 'pointer', fontSize: '14px', color: C.brown }}>
                  <input type="radio" name="price_range" value={p.id} checked={form.price_range === p.id} onChange={() => set('price_range', p.id)} style={{ accentColor: C.amber, flexShrink: 0 }} />
                  {p.label}
                </label>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setStep(1)} style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '10px', padding: '14px', color: C.muted, fontSize: '15px', cursor: 'pointer' }}>← Back</button>
              <button
                onClick={() => { if (form.categories.length === 0) { setError('Select at least one category.'); return }; setError(''); setStep(3) }}
                style={{ flex: 2, background: C.amber, color: '#fff', border: 'none', borderRadius: '10px', padding: '14px', fontFamily: f, fontSize: '16px', cursor: 'pointer' }}
              >
                Next →
              </button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div>
            <div style={{ fontFamily: f, fontSize: '18px', color: C.brown, marginBottom: '20px' }}>Final Details</div>

            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Business Bio</label>
              <textarea
                value={form.bio}
                onChange={e => set('bio', e.target.value)}
                placeholder="Describe your experience, specialties, and what makes your business stand out…"
                style={{ ...inp, minHeight: '100px', resize: 'vertical' }}
              />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={lbl}>Contractor License # (optional)</label>
              <input style={inp} value={form.license_number} onChange={e => set('license_number', e.target.value)} placeholder="CA License #" />
            </div>
            <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '20px', cursor: 'pointer', fontSize: '13px', color: C.brown }}>
              <input type="checkbox" checked={form.insurance_confirmed} onChange={e => set('insurance_confirmed', e.target.checked)} style={{ accentColor: C.amber, flexShrink: 0, marginTop: 2 }} />
              I confirm this business carries general liability insurance
            </label>

            {error && <div style={{ fontSize: '13px', color: C.danger, marginBottom: '12px' }}>{error}</div>}

            <div style={{ background: '#FFF8E7', border: `1px solid ${C.amber}44`, borderRadius: '10px', padding: '14px', marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', color: C.amber, fontWeight: '700', marginBottom: '4px', fontFamily: f }}>What happens next?</div>
              <div style={{ fontSize: '12px', color: C.muted, lineHeight: 1.5 }}>We review all applications manually. Approved contractors are listed in the Casavio directory and connected with homeowners in their area. No monthly fees.</div>
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => setStep(2)} style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '10px', padding: '14px', color: C.muted, fontSize: '15px', cursor: 'pointer' }}>← Back</button>
              <button
                onClick={handleSubmit}
                disabled={saving}
                style={{ flex: 2, background: saving ? C.border : C.amber, color: saving ? C.muted : '#fff', border: 'none', borderRadius: '10px', padding: '14px', fontFamily: f, fontSize: '16px', cursor: saving ? 'default' : 'pointer' }}
              >
                {saving ? 'Submitting…' : 'Submit Application'}
              </button>
            </div>
          </div>
        )}

        {error && step < 3 && <div style={{ fontSize: '13px', color: C.danger, marginTop: '10px' }}>{error}</div>}
      </div>
    </div>
  )
}
